import { cliente } from './api'
import { obtenerTokenStorage } from './sessionStorage'
import axios from 'axios'
let cancelToken
export default {
  obtenerOferta(folio) {
    return cliente.get('/credito/oferta_digital', {
      params: {
        FolioDigital: folio,
      },
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  obtenerFrecuenciaPlazoProducto(request, folio) {
    return cliente.get('/credito/frecuencia_plazo_pdcto', {
      params: {
        IdSubproducto: request,
        folioDigital: folio,
      },
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  obtenerPagoSimulado(request) {
    // console.log(request)
    // const obtieneEsquema = function (frecuencia) {
    //   switch (frecuencia) {
    //     case 'Mensual':
    //       return {
    //         esquema: 2,
    //         periodicidad: 1,
    //       }
    //     case 'Quincenal':
    //       return {
    //         esquema: 3,
    //         periodicidad: 2,
    //       }
    //     case 'Semanal':
    //       return {
    //         esquema: 5,
    //         periodicidad: 3,
    //       }
    //   }
    // }
    const datPago = {
      monto: request.monto.val,
      plazo:
        typeof request.plazo.val === 'number'
          ? request.plazo.val
          : request.plazo.val.val,
      tasa: request.tasa.val,
      cadaCuando: 1,
      fechaPtmo: new Date(),
      idEsquema: request.id_esquema
        ? request.id_esquema
        : request.frecuenciaSeleccionada.id_esquema, // obtieneEsquema(request.frecuenciaSeleccionada.val).esquema, //hay que obtenerlo de bd más adelante,
      periodicidad: request.id_periodicidad
        ? request.id_periodicidad
        : request.frecuenciaSeleccionada.id_periodicidad, // obtieneEsquema(request.frecuenciaSeleccionada.val)
      id_subproducto: request.tipoCredito,
    }
    if (cancelToken) {
      cancelToken.cancel('Request cancelado por cambio en los parametros')
    }
    cancelToken = axios.CancelToken.source()
    return cliente.post('/credito/obtiene_pago_simulado', datPago, {
      cancelToken: cancelToken.token,
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  insertarSolicitudDigital(request) {
    return cliente.post('/credito/solicitud_digital', request, {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  actualizaMontoSolicitudDigital(request) {
    return cliente.post('/credito/actualiza_monto_solicitud', request, {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  insertaDocumentos(request) {
    return cliente.post('/credito/documentos', request, {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  actualizarEstatusSolicitud(id_solicitud) {
    const request = {
      id_solicitud,
      id_status: 2,
      id_sub_status: 4,
      observaciones_devoluciones: '',
    }
    return cliente.post('/credito/actualiza_estatus_solicitud', request, {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  actualizarDomicilioSolicitud(request) {
    // const request = {
    //   id_solicitud,
    //   id_status: 2,
    //   id_sub_status: 4,
    //   observaciones_devoluciones: '',
    // }
    return cliente.post('/credito/actualiza_domicilio_solicitud', request, {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  inserta_log(request) {
    return cliente.post('/credito/inserta_log_digital_analitica', request, {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
}
